
    import './styles.scoped.css';
    export default {
  "root": "_root_1lf6d_3",
  "trigger": "_trigger_1lf6d_15",
  "dropdown": "_dropdown_1lf6d_18",
  "nowrap": "_nowrap_1lf6d_29",
  "open": "_open_1lf6d_32"
};
  